import random from "./random.jsx";

export default {
  random,
};
